import React, { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import PartnerApi from "../../helpers/PartnerApi";
import { success, error } from "../../features/toast/toastSlice";
import iconSign from "../../icons-svg/icon_signature_lisans_agreement(2).svg";

const normalizeNo = (v) => String(v || "").replace(/\s+/g, "").trim();
const extractApiError = (e) => {

  const ax = e?.response?.data?.error;
  if (ax?.message) return ax;

  if (e?.error?.message) return e.error;

  if (e?.message) return e;

  return { message: "Sign license agreement failed." };
};

const EditButtonSignAgreement = ({
  licenseNo,
  size = 20,
  ariaLabel = "Sign License Agreement",
  tooltip = "Sign License Agreement",
  className = "",
  disabled = false,
  showMoreInMessage = false, 
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const safeNo = useMemo(() => normalizeNo(licenseNo), [licenseNo]);

  const onClick = useCallback(
    async (evt) => {
      evt?.preventDefault?.();
      evt?.stopPropagation?.();

      if (loading) return;

      if (!safeNo) {
        dispatch(
          error({
            title: "Error",
            message: "License number is missing.",
            delay: 5000,
          })
        );
        return;
      }

      setLoading(true);
      try {
        const res = await PartnerApi.postSignLicenseAgreement({ licenseNo: safeNo });

        const ok =
          res?.success === true ||
          res?.success === "true" ||
          res?.result === "OK";

        if (!ok) {
          dispatch(
            error({
              title: "Error",
              message: "Sign license agreement failed.",
              delay: 6000,
            })
          );
          return;
        }

        dispatch(
          success({
            title: "Success",
            message: "License agreement signed successfully.",
            delay: 3000,
          })
        );
      } catch (e) {
        const apiErr = extractApiError(e);

        const msg = showMoreInMessage && apiErr?.more
          ? `${apiErr.message} (${apiErr.more})`
          : (apiErr?.message || "Sign license agreement failed.");

        dispatch(
          error({
            title: "Error",
            message: msg,
            delay: 6000,
          })
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch, loading, safeNo, showMoreInMessage]
  );

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading || disabled}
      title={tooltip}
      aria-label={ariaLabel}
      aria-busy={loading ? "true" : "false"}
      className={[
        "inline-flex items-center justify-center",
        "bg-transparent border-0 p-0 m-0",
        "cursor-pointer",
        "hover:opacity-90 active:opacity-80",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
        "disabled:opacity-60 disabled:cursor-not-allowed",
        className,
      ].join(" ")}
      style={{ pointerEvents: "auto" }}
    >
      <img
        src={iconSign}
        alt=""
        width={size}
        height={size}
        className="block"
        style={{
          width: size,
          height: size,
          pointerEvents: "none",
          opacity: loading ? 0.7 : 1,
        }}
      />
    </button>
  );
};

export default EditButtonSignAgreement;
